import { Activity } from '@cms-max/medicare-api-sdk'
import generator, { EventMapKeys } from './baseGenerator'

export const authRepGenerator = generator(({ i18n }) => {
  return ({
    // Auth Rep Print Drawer: Open
    authrep_printdrawer_opendrawer: {
      core: {
        property: 'MAX',
        activity: Activity.OpenDrawer,
        component: 'Authorized Representative',
        elementId: 'authrep_printdrawer_opendrawer'
      }
    },
    // Auth Rep Print Drawer: Open
    authrep_printdrawer_closedrawer: {
      core: {
        property: 'MAX',
        activity: Activity.CloseDrawer,
        component: 'Authorized Representative',
        elementId: 'authrep_printdrawer_closedrawer'
      }
    }
  })
})

export type AuthRepKeys = EventMapKeys<typeof authRepGenerator>

export default authRepGenerator
